export enum ApplicationActionTypes {
    RESET = 'APPLICATION/RESET'
}